export default {
  dark: 'Тъмен',
  light: 'Светъл',
};
